import { render, staticRenderFns } from "./QuizLayout.vue?vue&type=template&id=67880350"
import script from "./QuizLayout.vue?vue&type=script&lang=js"
export * from "./QuizLayout.vue?vue&type=script&lang=js"
import style0 from "./QuizLayout.vue?vue&type=style&index=0&id=67880350&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports